const TRACKED_QUERY_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "utm_id",
  "gclid",
  "fbclid",
  "embed",

  "msclkid",
  "gbraid",
  "wbraid",
  "gad_source",
  "gad_campaignid",

  "hsa_acc",
  "hsa_ad",
  "hsa_cam",
  "hsa_grp",
  "hsa_kw",
  "hsa_mt",
  "hsa_net",
  "hsa_src",
  "hsa_tgt",
  "hsa_ver",
  "bing_cam_id",

  "templateId",
  "embedId",
  "onExitUrl",
  "noFundraise",
  "isCreationFlow",

  "zlinkid",
] as const;

export const getTrackedQueryParams = (searchParams: URLSearchParams): Record<string, string> =>
  Object.fromEntries(
    TRACKED_QUERY_PARAMS.flatMap((key) => {
      const value = searchParams.get(key);
      return value === null ? [] : [[key, value]];
    })
  );
